import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Accordion, Card, Collapse, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { getCsvDataForSalesReport } from '../../utils/csvdatagetter'
import { ExportCSV } from '../_reusedcomponents/ExportCSVView'
import moment from 'moment'
import 'moment/locale/de'
import { useDateFilter } from '../../utils/filterutils'
import { parseFloatCurrency } from '../../utils/formatting/floatnumberparsing'
import { enumvaluetranslations } from '../../utils/enumvaluetranslations'
moment.locale('de')

const B2COrdersReportTableView = ({ report, filteredReport, handleSortReport, filterBar, setFilterBar, DateSelect, handleShowOrder, setOrderToView, handleFilterInput, handleOrderStateFilter, handleOrderProcessingStateFilter, filterOrderState, filterOrderProcessingState, orderStatesToFilter, orderProcessingStatesToFilter
}) => {
    console.log("B2COrdersReportTableView begin", report)
    const [group, setGroup] = useState("")
    console.log("B2COrdersReportTableView", handleShowOrder)

    const getTotalAmount = (filteredReports) => {
        let total = 0
        let numbers = filteredReports.map(x => x.Amount)
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const getTotalPrices = (filteredReports, field) => {
        let total = 0
        let numbers = filteredReports.map(x => parseFloat(x[field]))
        total = numbers.reduce((a, b) => a + b, 0)

        return total
    }

    const openOrder = (e, order, article, name) => {
        e.preventDefault()
        e.stopPropagation()
        console.log("openOrder", e)
        setOrderToView(order)

        handleShowOrder()
    }

    const grouping = (e, position) => {
        e.preventDefault()
        e.stopPropagation()

        console.log("setGroup", position)
        setGroup(position.BundleB2COrderTransactionsSysId)
    }

    const cancelGrouping = (e, position) => {
        e.preventDefault()
        e.stopPropagation()

        console.log("cancelGrouping", position)
        setGroup("")
    }

    useEffect(() => {
        console.log("Grouping", group)
    }, [group])


    const View = (filteredOrGroupedReport, grouped) => {
        console.log("filteredOrGroupedReport", filteredOrGroupedReport, grouped)
        return (
            <>
            <thead className="sticky-table-header">
                <th className="mainColumn"></th>
                    {grouped === false ? <th className="filterIndicator" onClick={() => setFilterBar(prev => prev = !filterBar)}>&#8711; {window.i18n('filteringOptions')}</th> : <th></th>}
                <th className="mainColumn">{window.i18n('salePoint')}
                        <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'OrderingPoint')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('saleDate')}
                        <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'SalesDate')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('articleNumberFaex')}
                        <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'ArticleIdFaex')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('articleNumberDesigner')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'ArticleNumberDesigner')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('articleName')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Name')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('colour')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Colour')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('size')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Size')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('amount')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Amount')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('salePrice')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'SalesPrice')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('salePrice')}
                    <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'SalesPriceInOverall')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('remark')}
                        <a href="" className="sort-link" onClick={(e) => handleSortReport(e, 'Remark')}>&#8593; &#8595;</a></th>
                <th className="mainColumn">{window.i18n('orderState')}</th>
                <th className="mainColumn">{window.i18n('orderProcessingState')}</th>
                <th></th>
            </thead>

            <thead>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
            </thead>

            {filterBar ? <thead>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>{DateSelect()}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </thead> : null}


            <tbody>
                {filteredOrGroupedReport.map(entry =>
                    <tr>
                        <td>
                            {grouped === false ?
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{window.i18n('particularOrder')}</Tooltip>}>
                                    <a className="edit-button" onClick={(e) => grouping(e, entry)}>&#x1F9FE;</a>
                                    </OverlayTrigger> :
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{window.i18n('particularOrderClose')}</Tooltip>}>
                                    <a className="edit-button" onClick={(e) => cancelGrouping(e, entry)}>&#10060;</a>
                                    </OverlayTrigger>
                            }
                        </td>
                        <td>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>{window.i18n('particularOrderPositionOpen')}</Tooltip>}>
                                <a className="edit-button" onClick={(e) => openOrder(e, entry)}>&#9998;</a>
                            </OverlayTrigger>
                        </td>
                        <td>{entry.OrderingPoint}</td>
                        <td>{entry.SalesDate}</td>
                        <td>{entry.ArticleIdFaex}</td>
                        <td>{entry.ArticleNumberDesigner}</td>
                        <td>{entry.Name}</td>
                        <td>{entry.Colour}</td>
                        <td>{entry.Size}</td>
                        <td className="numberColumn">{entry.Amount}</td>
                        <td className="numberColumn">{parseFloatCurrency(entry.SalesPrice)}</td>
                        <td className="numberColumn">{parseFloatCurrency(entry.SalesPriceInOverall)}</td>
                        <td>{entry.Remark}</td>
                        <td>{window.i18n(entry.OrderState)}</td>
                        <td>{window.i18n(entry.OrderProcessingState)}</td>
                    </tr>)
                }

                <tr className="stockReport-row">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{window.i18n('sum') + ":"}</td>
                    <td className="numberColumn">{getTotalAmount(filteredOrGroupedReport)}</td>
                    <td className="numberColumn">{parseFloatCurrency(getTotalPrices(filteredOrGroupedReport, "SalesPrice"))}</td>
                    <td className="numberColumn">{parseFloatCurrency(getTotalPrices(filteredOrGroupedReport, "SalesPriceInOverall"))}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
            </>
        )
    }

    return (
        <>
            {group && <p className="threecmSpace"></p>}
            {group &&
                <h1 placement="center">{window.i18n('particularOrder')}</h1>}
            {group && 
                <div className="tablet-transactions">
                    <Table className="articletype-table table-sm table-sales-striped-immediate ">
                        {View(report.filter(x => x.BundleB2COrderTransactionsSysId === group), true)}
                    </Table>
                </div>}
            {group && <p className="threecmSpace"></p>}
            <h1 placement="center">{window.i18n('allOrderedArticles')}</h1>
            <div className="inline">
                <FormControl className="globalSearch" as="input" placeholder={window.i18n('search...')} onChange={handleFilterInput}></FormControl>
                <FormControl className="globalSearch" as="select" value={filterOrderState}
                    focusFirstItemOnShow='keyboard' onChange={(e) => handleOrderStateFilter(e)}>
                    <option value="default">{window.i18n('orderStateFiltering')}</option>
                    {orderStatesToFilter.map(state =>
                        <option value={state} >{window.i18n(state)}</option>)
                    }
                </FormControl>
                <FormControl className="globalSearch" as="select" value={filterOrderProcessingState}
                    focusFirstItemOnShow='keyboard' onChange={(e) => handleOrderProcessingStateFilter(e)}>
                    <option value="default" id={"default"}>{window.i18n('orderProgressStateFiltering')}</option>
                    {orderProcessingStatesToFilter.map(state =>
                        <option value={state}>{window.i18n(state)}</option>)
                    }
                </FormControl>
            </div>
            <div className="tablet-transactions">
                <Table className="articletype-table table-sm table-sales-striped-immediate ">
                    {View(filteredReport, false)}
                </Table>
            </div>
        </>
    )
}

export { B2COrdersReportTableView }

